export default __webpack_public_path__ + "static/media/rtg-2.0cfd006d.svg";